export function getCenterFromCoordinates(coordinates) {
  if (!coordinates || coordinates.length === 0) {
    return [0, 0];
  }

  const longitudes = coordinates.map((coord) => coord[0]);
  const latitudes = coordinates.map((coord) => coord[1]);

  const minLng = Math.min(...longitudes);
  const maxLng = Math.max(...longitudes);
  const minLat = Math.min(...latitudes);
  const maxLat = Math.max(...latitudes);

  const centerLng = (minLng + maxLng) / 2;
  const centerLat = (minLat + maxLat) / 2;

  return [centerLng, centerLat];
}
